// extracted by mini-css-extract-plugin
export default {"modalImage":"dRc0-","title":"OmmhW","modalBlock":"PuUJ5","closeButton":"msLqa","rewardButtons":"QTuTx"};